import { render, staticRenderFns } from "./MarketingHint.vue?vue&type=template&id=3e20fa56&scoped=true"
import script from "./MarketingHint.vue?vue&type=script&lang=js"
export * from "./MarketingHint.vue?vue&type=script&lang=js"
import style0 from "./MarketingHint.vue?vue&type=style&index=0&id=3e20fa56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20fa56",
  null
  
)

export default component.exports